/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Point
 */
export interface Point {
    /**
     * 
     * @type {number}
     * @memberof Point
     */
    lat: number;
    /**
     * 
     * @type {number}
     * @memberof Point
     */
    lon: number;
}

/**
 * Check if a given object implements the Point interface.
 */
export function instanceOfPoint(value: object): value is Point {
    if (!('lat' in value) || value['lat'] === undefined) return false;
    if (!('lon' in value) || value['lon'] === undefined) return false;
    return true;
}

export function PointFromJSON(json: any): Point {
    return PointFromJSONTyped(json, false);
}

export function PointFromJSONTyped(json: any, ignoreDiscriminator: boolean): Point {
    if (json == null) {
        return json;
    }
    return {
        
        'lat': json['lat'],
        'lon': json['lon'],
    };
}

export function PointToJSON(value?: Point | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'lat': value['lat'],
        'lon': value['lon'],
    };
}

